<div class="channel-community-chat">
  <mat-sidenav-container class="h-screen flex" *ngIf="!isBlockedChannel">
    <mat-sidenav #sidenav mode="side" position="end" [ngClass]="{ 'thread-width': threadMessage }" [ngStyle]="{
      'background-color': settingsData?.space_bg_primary_color,
      'color': settingsData?.space_font_primary_color
    }">
      <div class="d-flex justify-between fs-22 fw-600 align-center p-10 pl-20">
        <span class="dynamic-font">{{threadMessage ? 'Thread' : 'Details'}}</span>
        <i class="fa fa-close close-btn pointer" (click)="closeSidenav()"></i>
      </div>
      <div *ngIf="!threadMessage">
        <div class="details-section channel-details m-20 mt-0 p-10 pt-20 fs-16 fw-600" [ngStyle]="{
          'background-color': settingsData?.space_main_bg_color
        }">
          <div class="pb-10">
            <span [ngStyle]="{'color':settingsData?.space_font_main_color,'opacity':'0.5'}" class="dynamic-font">Space Name</span>
            <span [ngStyle]="{'color':settingsData?.space_font_main_color}" class="dynamic-font"> {{channelDetails?.channelName}}</span>
          </div>
          <div class="pb-10">
            <span [ngStyle]="{'color':settingsData?.space_font_main_color,'opacity':'0.5'}"
              *ngIf="channelDetails?.teamName" class="dynamic-font">Space Group</span>
            <span [ngStyle]="{'color':settingsData?.space_font_main_color}" class="dynamic-font"> {{channelDetails.teamName}}</span>
          </div>

          <div class="pb-10">
            <span [ngStyle]="{'color':settingsData?.space_font_main_color,'opacity':'0.5'}" class="dynamic-font">Created by</span>
            <span [ngStyle]="{'color':settingsData?.space_font_main_color}" class="dynamic-font"><span class="capitalize">
                {{channelDetails?.createdByName}},</span> {{
              channelDetails?.createdOn | date: 'MMM dd yyyy' }}</span>
          </div>
<!-- fan does not have access to enable or disable tips -->
          <!-- <div class="pb-10">
            <mat-slide-toggle style="margin-top: 10px;" [checked]="channelDetails?.enableTips" disabled>
              Tips
            </mat-slide-toggle>
          </div> -->

          
        </div>

        <div class="details-section m-20 mt-10 p-10 pt-20 fs-14" [ngStyle]="{
          'background-color': settingsData?.space_main_bg_color,
          'font-family': settingsData?.font_family
        }">
          <div class="d-flex ml-10 mb-15">
            <img src="assets/community-people.svg" class="people-img"
              [style.filter]="getSvgFilter(settingsData?.space_main_bg_color)" />
            <span class="pl-10 fs-22 fw-600 dynamic-font" [ngStyle]="{'color':settingsData?.space_font_main_color}">Members
              ({{channelDetails?.memberCount}})</span>
          </div>
          <div class="channel-search mtb-10 mb-0" *ngIf="channelDetails?.channelVisibility == 'private'" [ngStyle]="{
            'background-color': settingsData?.space_bg_primary_color ? settingsData?.space_bg_primary_color : settingsData?.bg_tertiary_color,
          'color':settingsData?.space_font_primary_color}">
            <i class="fa fa-search search-icon" aria-hidden="true" [ngStyle]="{
              'color': settingsData?.space_font_primary_color,
            }"></i>
            <input matInput [(ngModel)]="searchMember" autocomplete="off" (keyup.enter)="MemberSearch()"
              (ngModelChange)="onTypeSearch($event)" placeholder="Search for a member..." class="search-textbox dynamic-font"
              [ngStyle]="{'color':settingsData?.space_font_primary_color}">
          </div>
          <!-- <span class="fs-16 pointer" *ngIf="channelDetails?.channelVisibility == 'private'" (click)="addTeamMember()">
            <img src="assets/add-member.svg" class="m-10" [style.filter]="getSvgFilter(settingsData?.space_main_bg_color)"/>
            Manage Members
          </span> -->
          <div class="h-44" [ngStyle]="{ '--scroll-color': settingsData?.space_bg_secondary_color || '#888' }">
            <div class="d-flex align-center" *ngFor="let user of filteredTeamMembers">
              <span *ngIf="!user?.profileUrl" class="member-dp d-flex align-center j-c m-10 uppercase ml-0 fw-600"
                [ngStyle]="{'background-color': user?.userColor }">{{ user.shortName }}</span>
              <span *ngIf="user?.profileUrl" [ngStyle]="{'background-image':' url(' + user?.profileUrl + ')'}"
                class="artist-pic with-profile-pic mlr-10 ml-0 shrink-0">
              </span>
              <span class="user-details fs-12" [ngStyle]="{
                'color': settingsData?.space_font_main_color}">
                <span class="text-capitalize fs-15 dynamic-font">{{user.nickname}} {{user.userType == 'partner' ? '(Admin)':
                  ''}}</span>
                Added on {{user.createdOn | date: 'dd MMMM yyyy'}}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="thread-height" *ngIf="threadMessage">
        <div class="chat-content pt-0 plr-15 w-100">
          <div class="messages p-10" id="thread-inner-box" (scroll)="onScroll('thread-inner-box')" [ngStyle]="{
            'background-color': settingsData?.space_main_bg_color ,
            'color': settingsData?.space_font_main_color,
            '--scroll-color': settingsData?.space_bg_secondary_color || '#888' 
          }">
            <div class="mb-30" *ngFor="let message of combinedThreadMessages; let i = index">
              <div [ngClass]="{'selected-msg': selectedThreadMsg?.messageId == message?.messageId }">
                <div class="msg-info d-flex" [ngClass]="{
                  'row-reverse': message.sentMsg,
                  'selected-msg': selectedMsg?.messageId == message?.messageId
                }" [ngStyle]="{
                  'background-color': hoveredMsgId === message.messageId
                    ? hexToRgba(settingsData?.space_bg_primary_color, 0.5)
                    : ' '
                }" (mouseenter)="hoveredMsgId = message.messageId" (mouseleave)="hoveredMsgId = null">
                  <!-- <span *ngIf="!message?._sender?.profileUrl || message.blockedUser"
                    class="profile d-flex align-center j-c mlr-10 uppercase ml-0 fw-600 shrink-0"
                    [ngStyle]="{'background-color': message._sender?.userColor }">{{message?._sender?.shortName}}</span> -->
                  <span *ngIf="!message?._sender?.profileUrl || message.blockedUser"
                    class="profile d-flex align-center j-c mlr-10 uppercase ml-0 fw-600 shrink-0 dynamic-font"
                    [ngStyle]="{'background-color': settingsData?.space_bg_secondary_color,'color':settingsData?.space_font_secondary_color }">{{message?._sender?.shortName}}</span>
                  <span *ngIf="message?._sender?.profileUrl && !message.blockedUser"
                    [ngStyle]="{'background-image':' url(' + message?._sender?.profileUrl + ')'}"
                    class="artist-pic with-profile-pic mlr-10 ml-0 shrink-0">
                  </span>
                  <span>
                    <div class="d-flex align-center justify-between" [ngClass]="{ 'row-reverse': message.sentMsg }">
                      <span class="d-flex" [ngClass]="{ 'row-reverse': message.sentMsg }">
                        <span class="fw-600 mr-10">{{message?._sender?.nickname}}</span>
                        <span [ngStyle]="{'color': settingsData?.space_font_main_color}"
                          class="fs-12 time-text mr-10">{{ message?.timestamp && message?.timestamp !== 'Invalid Date' ? getFormattedDate(message.timestamp) : '' }}
                          {{ message?.msgTime && message?.msgTime !== 'Invalid Date' ? message.msgTime : '' }}</span>
                      </span>
                      <span class="actions-section relative p-5 plr-10 mr-10" [ngStyle]="{
                        'background-color': settingsData?.space_bg_secondary_color,
                        'color': settingsData?.space_font_secondary_color,
                        'font-family': settingsData?.font_family
                      }" *ngIf="selectedThreadMsg?.messageId == message?.messageId">
                        <img class="mr-2 pointer"
                          [ngClass]="{ 'mr-10': !message.sentMsg && ((!message.blockedUser && message.userType != 'creator') || !message.isBlocked) }"
                          [ngClass]="{ 'opacity-7': emojiMsgId === message.messageId }" src="assets/reaction-emoji.svg"
                          (click)="openCloseEmoji(message.messageId, true)" />
                        <img class="pointer ml-2" [matMenuTriggerFor]="menu" src="assets/more-actions.svg"
                          (click)="addStyles()"
                          *ngIf="!message.sentMsg && ((!message.blockedUser && message.userType != 'creator') || !message.isBlocked)" />
                        <mat-menu #menu="matMenu">
                          <button *ngIf="!message.blockedUser && message.userType != 'creator'" mat-menu-item
                            (click)="reportUser(message, true)">
                            <span class="dynamic-font">
                              <img src="assets/Information.svg"
                                [style.filter]="getSvgFilter(settingsData?.space_bg_primary_color)" />
                              Report User
                            </span>
                          </button>
                          <button *ngIf="!message.isBlocked" mat-menu-item (click)="reportContent(message, true)">
                            <span class="dynamic-font">
                              <img src="assets/Information.svg"
                                [style.filter]="getSvgFilter(settingsData?.space_bg_primary_color)" />
                              Report Message
                            </span>
                          </button>
                        </mat-menu>
                        <div id="emojiPicker1" *ngIf="emojiMsgId === message?.messageId && !displayEmojiPicker">
                          <emoji-mart [showPreview]="false" [isNative]="true" [set]="'native'"
                            (emojiClick)="addEmoji(message.timetoken, message.messageId, $event, true)"
                            [showSingleCategory]="false" [emojisToShowFilter]="filter" [enableSearch]="false"
                            [ngClass]="message.sentMsg ? 'emoji-position-left' : 'emoji-position-right'">
                          </emoji-mart>

                        </div>
                      </span>
                    </div>
                    <div class="msg-text p-15 mt-10 pointer dynamic-font" (mouseenter)="selectThreadMessage(message)" [ngStyle]="{
                      'background-color': hexToRgba(settingsData?.space_bg_secondary_color, 0.9),
                      'color': settingsData?.space_font_secondary_color }">
                      <pre class="mb-0" *ngIf="!message.isBlocked"
                        [ngClass]="{ 'clamp-5-lines': !message.isExpanded && message?.message?.length > 1000 }">{{ message.message }}</pre>
                      <span *ngIf="message.isBlocked">
                        <app-svg [icon]="'community_block_icon'"></app-svg>
                        <span class="pt-2px dynamic-font"> This message has been blocked</span>
                      </span>
                      <div class="msg-files mt-10" *ngIf="message.files?.length > 0 && !message.isBlocked">
                        <ng-container *ngFor="let file of message.files">
                          <div *ngIf="file.type === 'image'" class="file-preview">
                            <img [src]="file.url" alt="Image" class="image-preview" />
                          </div>
                          <div *ngIf="file.type === 'video'" class="file-preview dynamic-font">
                            <video controls class="video-preview">
                              <source [src]="file.url" type="video/mp4">
                              Your browser does not support the video tag.
                            </video>
                          </div>
                          <div *ngIf="file.type === 'audio'" class="file-preview dynamic-font">
                            <audio controls class="audio-preview">
                              <source [src]="file.url" type="audio/mpeg">
                              Your browser does not support the audio element.
                            </audio>
                          </div>
                          <div *ngIf="file.type === 'document'"
                            class="file-preview pl-15 pr-5 document-preview-container">
                            <div class="document-icon">
                              <i class="fa fa-file-text mr-15" aria-hidden="true"></i>
                              <span class="document-name dynamic-font" matTooltip="{{ file.name }}">{{ file.name?.length > 30 ?
                                (file.name | slice:0:30) + '...' : file.name }}</span>
                            </div>
                            <button mat-icon-button [matMenuTriggerFor]="menu2" [disableRipple]="true">
                              <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu2="matMenu">
                              <button mat-menu-item (click)="downloadFile(file)">
                                <span class="dynamic-font">Download</span>
                              </button>
                            </mat-menu>
                          </div>
                        </ng-container>
                      </div>
                      <span *ngIf="message?.message?.length > 1000 && !message.isBlocked"
                        class="expand-text pointer d-block text-right m-10 dynamic-font" (click)="toggleMessage(message)">
                        {{ message.isExpanded ? 'Read Less' : 'Read More' }}
                      </span>
                    </div>
                    <div class="msg-reactions mt-10" [ngClass]="{ 'text-right': message.sentMsg }">
                      <ng-container *ngFor="let emoji of getEmojiKeys(message.reactions)">
                        <span class="fs-14 pointer actions"
                          [ngClass]="{ 'ml-5': message.sentMsg, 'mr-5': !message.sentMsg }"
                          (mouseenter)="showReactionUsers(emoji, message, threadEmojiMenuTrigger)"
                          (mouseleave)="hideReactionUsers(threadEmojiMenuTrigger)"
                          #threadEmojiMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="threadEmojiMenu" [ngStyle]="{
                            'background-color': settingsData?.bg_secondary_color,
                            'color': settingsData?.font_primary_color,
                            'font-family': settingsData?.font_family
                          }">
                          <span class="mr-5 reaction">{{emoji}}</span>
                          <span>{{message.reactions[emoji]?.count}}</span>
                        </span>
                        <!-- Dropdown Menu for Reactions -->
                        <mat-menu #threadEmojiMenu="matMenu" class="emoji-menu">
                          <ng-container *ngIf="reactionUsers.length > 0">
                            <button class="reaction-button" [ngStyle]="{'width' : '230px'}" mat-menu-item
                              *ngFor="let user of reactionUsers">
                              <span class="reaction-text">
                                <span *ngIf="!user.profileUrl"
                                  class="profile d-flex align-center j-c mr-10 uppercase fw-600 shrink-0"
                                  [ngStyle]="{'background-color': user?.userColor }">{{user.shortName}}</span>
                                <span *ngIf="user.profileUrl"
                                  [ngStyle]="{'background-image':' url(' + user.profileUrl + ')'}"
                                  class="artist-pic with-profile-pic mr-10 shrink-0">
                                </span>
                                <span class="user-name capitalize">
                                  {{ user.nickname > 14 ? (user.nickname | slice:0:11) + '...' : user.nickname }}
                                </span>
                              </span>
                              <span>{{hoveredReaction}}</span>
                            </button>
                          </ng-container>
                        </mat-menu>
                      </ng-container>
                    </div>
                  </span>
                </div>
              </div>
              <div class="d-flex align-center pt-15 w-100"
                *ngIf="threadMessage.threadReplies?.length > 0 && message.messageId == threadMessage?.messageId">
                <span class="thread-line" [ngStyle]="{
                  'background-color':settingsData?.space_bg_secondary_color
                }"></span>
                <span [ngStyle]="{
                  'color':settingsData?.space_bg_secondary_color
                }" class="plr-12 reply-text dynamic-font">{{threadMessage.threadReplies.length}}
                  {{threadMessage.threadReplies.length == 1 ? 'Reply' : 'Replies'}}</span>
              </div>
            </div>
          </div>

          <emoji-mart *ngIf="isThreadEmojiInputVisible" [showPreview]="false" [isNative]="true" [set]="'native'"
            (emojiClick)="addEmojiToInput($event, true)" [showSingleCategory]="false" [emojisToShowFilter]="filter"
            [enableSearch]="false" class="emoji-thread-picker">
          </emoji-mart>

          <div class="input-box">
            <div [ngStyle]="{
              'background-color': settingsData?.space_bg_secondary_color,
              'color': settingsData?.font_primary_color,
              'font-family': settingsData?.font_family,
              padding: '6px'
            }">
              <span class="icon-group p-0 2">
                <app-svg class="icon" [icon]="'file-upload'" [color]="settingsData?.font_primary_color"
                  (click)="userInfo?.id ? fileInputThread.click() :$event.stopPropagation()" matTooltip="Attach files"
                  [ngStyle]="{
                    'padding': '7px 9px 7px 9px',
                    'border-radius': '6px',
                    'margin-right': '6px',
                    'margin-top': '3px',
                    'cursor':userInfo?.id ? 'pointer' :'not-allowed'
                  }"></app-svg>
                <input type="file" #fileInputThread accept="*" multiple style="display: none"
                  (change)="onFileSelected($event, true)" />
                <app-svg class="icon pointer emoji-input" [icon]="'emoji-input'" [color]="settingsData?.font_primary_color" (click)="toggleEmojiPicker(true)"
                  matTooltip="Emoji" [ngStyle]="{'padding': '4px', 'border-radius': '6px','margin-top': '3px'}"></app-svg>
                <!-- <mat-icon class="icon poll pointer" (click)="createPoll()" matTooltip="Polls">poll</mat-icon> -->
              </span>
            </div>

            <div class="message-container">
              <div>
                <textarea #threadMessageInput [ngClass]="{'h-50': !threadInput.length}" [(ngModel)]="threadInput"
                  (keydown)="handleKeyDown($event, true)" placeholder="Share your thoughts..." rows="1"
                  (input)="adjustTextareaHeight($event)"></textarea>
                <div class="file-tags plr-10 pb-10" *ngIf="threadSelectedFiles.length > 0">
                  <div class="d-flex align-center file-tag fs-15 ptb-5 plr-10"
                    [ngStyle]="{ 'background-color': settingsData?.subs_bg_primary_color }"
                    *ngFor="let file of threadSelectedFiles; let i = index">
                    <span class="file-name p-0 dynamic-font" matTooltip="{{ file.name }}">
                      {{ file.name.length > 35 ? (file.name | slice:0:35) + '...' : file.name }}
                    </span>
                    <span class="pointer remove-file p-0 pt-5" (click)="removeFile(i, true)">
                      <mat-icon>close</mat-icon>
                    </span>
                  </div>
                </div>
              </div>
              <button class="send-button" (click)="sendMessage(true)" [ngStyle]="{
                'background-color': settingsData?.space_bg_secondary_color,
                'border': 'none',
                'border-radius': '15px',
                'cursor': userInfo?.id ? 'pointer' : 'not-allowed'
              }">
                <div class="send-icon text-center fs-20 pointer m-12 pt-5" fxFlex="15%" fxFlex.xs="25%">
                  <span class="material-icons  notranslate"
                    [ngStyle]="{'cursor': userInfo?.id ? 'pointer' : 'not-allowed'}">
                    send
                  </span>
                </div>
              </button>
            </div>
          </div>

        </div>
      </div>
    </mat-sidenav>

    <!-- Main Content -->
    <mat-sidenav-content class="w-full" [ngStyle]="{
        'background-color': settingsData?.space_main_bg_color,
        'color': settingsData?.space_font_main_color
      }">
      <ng-container *ngIf="isChannelAvailable;else contentLoading">
        <div>
          <div class="fs-22 fw-600 pl-10 pb-10 pr-30 d-flex justify-between align-center position-relative"
            [ngClass]="{ 'pt-15 pb-20': sidenav.opened }">
            <span class="dynamic-font">{{channelDetails?.channelName}}</span>

              <span class="pointer ml-auto" (click)="shareSpace(channelDetails)"
                (click)="$event.stopPropagation()" *ngIf="channelDetails?.channelVisibility ==='public'">
                <div class="fs-20"><i class="fa fa-share-alt"></i>
                </div>
             </span>
              <div *ngIf="channelDetails.socialShareClick" #menu class="share-link-popup"
                  (click)="$event.stopPropagation()">
                  <app-social-share-link [slugName]="router.url"
                      [sharedFrom]="'SHARE_SPACE_LINK'" [settingsData]="settingsData ? settingsData :'' " (closeShareEvent)="closeSocialSharePopup($event)">
                  </app-social-share-link>
              </div>

            <button mat-icon-button [matMenuTriggerFor]="menu" (click)="addStyles()" [disableRipple]="true"
              class="ml-10" *ngIf="!sidenav.opened">
              <mat-icon [ngStyle]="{
                'color': settingsData?.space_font_main_color}">more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <div *ngFor="let action of menuActions" class="menu-items p-10 d-flex"
                (click)="isActionAllowed(action.label) ? action.handler() : $event.stopPropagation()" [ngStyle]="{
                  'color': settingsData?.space_font_primary_color,
                  'cursor': isActionAllowed(action.label) ? 'pointer' : 'not-allowed'
                }" [ngClass]="{ 'disable': !isActionAllowed(action.label) }">
                <mat-icon class="mr-10">{{ action.icon }}</mat-icon>
                <span class="dynamic-font">{{ action.label }}</span>
              </div>
            </mat-menu>

          </div>
          <div class="chat-content plr-30 w-100" [ngStyle]="{
                      'color': settingsData?.font_secondary_color
                    }">
            <div class="messages p-10" id="channel-inner-box" (scroll)="onScroll('channel-inner-box')"
              [ngStyle]="{ '--scroll-color': settingsData?.space_bg_secondary_color || '#888' }">
              <div *ngFor="let message of messagesList; let i = index"
                [id]="message.newMsgsStartPoint ? 'unread-start-point' : null">
                <div *ngIf="message.newMsgsStartPoint" class="divider d-flex align-center text-center mtb-20">
                  <span [ngStyle]="{ 'color': settingsData?.space_font_primary_color }"
                    class="divider-text plr-10 fw-600 fs-20 dynamic-font">New Messages</span>
                </div>
                <div *ngIf="message?.timestamp && displayDate(i)" class="d-flex align-center text-center mtb-20">
                  <span [ngStyle]="{ 'color': settingsData?.space_font_main_color }"
                    class="plr-10 fw-600 fs-20 w-100 dynamic-font">{{ getFormattedDate(message.timestamp) }}</span>
                </div>
                <div class="msg-info d-flex mb-30" [ngClass]="{
                'row-reverse': message.sentMsg,
                'selected-msg': selectedMsg?.messageId == message?.messageId,
                'p-10': selectedMsg?.messageId == message?.messageId
              }" [ngStyle]="{
                'background-color': selectedMsg?.messageId === message.messageId
                  ? hexToRgba(settingsData?.space_bg_primary_color, 0.5)
                  : ' '
              }" (mouseenter)="hoveredMsgId = message.messageId" (mouseleave)="hoveredMsgId = null">
                  <!-- <span *ngIf="!message?._sender?.profileUrl || message.blockedUser" [ngStyle]="{
                    'background-color': settingsData?.bg_secondary_color}"
                    class="profile d-flex align-center j-c mlr-10 uppercase ml-0 fw-600 shrink-0">{{message?._sender?.shortName}}</span> -->
                  <span *ngIf="!message?._sender?.profileUrl || message.blockedUser"
                    [ngStyle]="{
                      'background-color': settingsData?.space_bg_secondary_color, 'color':settingsData?.space_font_secondary_color}"
                    class="profile d-flex align-center j-c mlr-10 uppercase ml-0 fw-600 shrink-0">{{message?._sender?.shortName}}</span>
                  <span *ngIf="message?._sender?.profileUrl && !message.blockedUser"
                    [ngStyle]="{'background-image':' url(' + message?._sender?.profileUrl + ')'}"
                    class="artist-pic with-profile-pic mlr-10 ml-0 shrink-0">
                  </span>
                  <span>
                    <div class="d-flex align-center justify-between" [ngClass]="{ 'row-reverse': message.sentMsg }">
                      <span class="d-flex" [ngClass]="{ 'row-reverse': message.sentMsg }">
                        <span [ngStyle]="{'color': settingsData?.space_font_main_color}"
                          class="fw-600 mr-10 capitalize dynamic-font">{{message?._sender?.nickname}}</span>
                        <span [ngStyle]="{'color': settingsData?.space_font_main_color}"
                          class="fs-12 time-text mr-10">{{ message?.msgTime && message?.msgTime !== 'Invalid Date' ? message.msgTime : '' }}</span>
                      </span>
                      <span class="actions-section relative p-5 plr-10 mr-10" [ngStyle]="{
                                                          'background-color': settingsData?.space_bg_secondary_color,
                                                          'color': settingsData?.space_font_secondary_color
                                                        }" *ngIf="selectedMsg?.messageId == message?.messageId">
                        <img class="mr-10 pointer" [ngClass]="{ 'opacity-7': emojiMsgId === message.messageId }"
                          src="assets/reaction-emoji.svg" (click)="openCloseEmoji(message.messageId)" />
                        <img class="mr-0 pointer"
                          [ngClass]="{ 'mr-10': !message.sentMsg && ((!message.blockedUser && message.userType != 'creator') || !message.isBlocked) }"
                          src="assets/threads.svg" (click)="openSidenav(message)" />
                        <img class="pointer" [matMenuTriggerFor]="menu" src="assets/more-actions.svg"
                          (click)="addStyles()"
                          *ngIf="!message.sentMsg && ((!message.blockedUser && message.userType != 'creator') || !message.isBlocked)" />
                        <mat-menu #menu="matMenu">
                          <button *ngIf="!message.blockedUser && message.userType != 'creator'" mat-menu-item
                            (click)="reportUser(message)">
                            <span [ngStyle]="{'color': settingsData?.space_font_primary_color}" class="dynamic-font">
                              <img src="assets/Information.svg"
                                [style.filter]="getSvgFilter(settingsData?.space_bg_primary_color)" />
                              Report User
                            </span>
                          </button>
                          <button *ngIf="!message.isBlocked" mat-menu-item (click)="reportContent(message)">
                            <span [ngStyle]="{'color': settingsData?.space_font_primary_color}" class="dynamic-font">
                              <img src="assets/Information.svg"
                                [style.filter]="getSvgFilter(settingsData?.space_bg_primary_color)" />
                              Report Message
                            </span>
                          </button>
                        </mat-menu>
                        <div id="emojiPicker" *ngIf="emojiMsgId === message?.messageId && displayEmojiPicker">
                          <emoji-mart [showPreview]="false" [isNative]="true" [set]="native"
                            (emojiClick)="addEmoji(message.timetoken, message.messageId, $event)"
                            [showSingleCategory]="false" [emojisToShowFilter]="filter" [enableSearch]="false" [style]="{ position: 'absolute',
                                                                    width: '280px',
                                                                    left: message.sentMsg ? 'auto' : '60px',
                                                                    right: message.sentMsg ? '60px' : 'auto' }">
                          </emoji-mart>
                        </div>
                      </span>
                    </div>
                    <div class="msg-text p-15 mt-10 pointer dynamic-font" [ngClass]="{ 'row-reverse': message.sentMsg }"
                      (mouseenter)="selectMessage(message)" [ngStyle]="{
                        'background-color': hexToRgba(settingsData?.space_bg_secondary_color, 0.5),
                        'color': settingsData?.space_font_secondary_color }">
                      <pre class="mb-0" *ngIf="!message.isBlocked"
                        [ngClass]="{ 'clamp-5-lines': !message.isExpanded && message?.message?.length > 1000 }">{{ message.message }}</pre>
                      <span class="align-bottom" *ngIf="message.isBlocked">
                        <app-svg [icon]="'community_block_icon'"></app-svg>
                        <span class="dynamic-font"> This message has been blocked</span>
                      </span>
                      <!-- <span *ngIf="message.type === 'poll'" class="poll-card-container"
                        [ngClass]="{ 'row-reverse': message.sentMsg }"
                        [ngStyle]="{
                          'background-color': settingsData?.bg_secondary_color,
                          'color': settingsData?.font_primary_color,
                          'font-family': settingsData?.font_family
                        }">
                        <div class="poll-card"
                          [ngStyle]="{
                            'background-color': settingsData?.form_bg_primary_color,
                            'color': settingsData?.font_primary_color,
                            'border-radius': '10px',
                            'padding': '10px'
                          }">
                          <div class="poll-question" [ngStyle]="{ 'font-weight': 'bold' }">{{ message.question }}</div>
                      
                          <div class="poll-options">
                            <ng-container *ngFor="let option of message.options">
                              <div
                                class="poll-option"
                                (click)="onVoteOptionClick(message, option.id, $event)"
                                [ngStyle]="{
                                  'margin': '6px 0',
                                  'cursor': 'pointer',
                                  'display': 'flex',
                                  'align-items': 'center',
                                  'justify-content': 'space-between',
                                  'background-color': isOptionSelected(message, option.id) ? settingsData?.form_bg_secondary_color : 'transparent',
                                  'border': '1px solid ' + settingsData?.form_bg_secondary_color,
                                  'padding': '6px 10px',
                                  'border-radius': '6px',
                                  'color': settingsData?.font_primary_color
                                }"
                              >
                                <div style="display: flex; align-items: center;">
                                  <div
                                    [ngStyle]="{
                                      'height': '12px',
                                      'width': '12px',
                                      'border-radius': '50%',
                                      'border': '2px solid ' + settingsData?.font_primary_color,
                                      'background-color': isOptionSelected(message, option.id) ? settingsData?.font_primary_color : 'transparent',
                                      'margin-right': '8px'
                                    }"
                                  ></div>
                                  <label>{{ option.option }}</label>
                                </div>
                                <span class="vote-count">{{ message.votesPerOption?.[option.id] || 0 }} {{ (message.votesPerOption?.[option.id] || 0) === 1 ? 'vote' : 'votes' }}</span>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </span> -->
                      <!-- <span *ngIf="message.type === 'poll' && !message.isBlocked" class="poll-card-container"
                        [ngClass]="{ 'row-reverse': message.sentMsg }" [ngStyle]="{
        'background-color': settingsData?.bg_secondary_color,
        'color': settingsData?.font_primary_color,
        'font-family': settingsData?.font_family
      }"> -->
                      <!-- 'background-color': hexToRgba(settingsData?.space_bg_secondary_color, 0.5), -->
                      <div class="poll-card" *ngIf="message.type === 'poll' && !message.isBlocked" [ngStyle]="{
         
         'color': settingsData?.space_font_primary_color,
         'border-radius': '10px',
         'padding': '10px'
       }">
                        <div class="poll-question dynamic-font">{{ message.question }}</div>

                        <div class="poll-options">
                          <ng-container *ngFor="let option of message.options">
                            <div class="poll-option">
                              <span style="display: flex; align-items: center;">
                                <!-- Use ngModel only for single-response polls -->
                                <input [type]="message.isAllowMultipleResponses ? 'checkbox' : 'radio'"
                                  [name]="message.isAllowMultipleResponses ? 'poll-' + message.id + '-' + option.id : 'poll-' + message.id"
                                  [class.radio-style]="message.isAllowMultipleResponses"
                                  [checked]="message.isAllowMultipleResponses ? isOptionSelected(message, option.id) : isOptionSelected(message, option.id)"
                                  [value]="option.id" [(ngModel)]="message.selectedOption"
                                  (change)="onVoteOptionClick(message, option.id, $event)" [ngStyle]="{
                                      '--custom-radio-color': settingsData?.space_font_primary_color || '#007BFF'
                                    }" />
                                <label style="margin-left: 6px;">{{ option.option }}</label>
                              </span>
                              <span class="vote-count">{{ message.votesPerOption?.[option.id] || 0 }} {{ (message.votesPerOption?.[option.id] || 0) === 1 ? 'vote' : 'votes' }}</span>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                      <!-- </span> -->

                      <div class="msg-files mt-10" *ngIf="message.files?.length > 0 && !message.isBlocked">
                        <ng-container *ngFor="let file of message.files">
                          <div *ngIf="file.type === 'image'" class="file-preview">
                            <img [src]="file.url" alt="Image" class="image-preview"
                              (click)="openImagePreview(file.url, message)" style="cursor: pointer;" />
                          </div>
                          <div *ngIf="file.type === 'video'" class="file-preview dynamic-font">
                            <video controls class="video-preview">
                              <source [src]="file.url" type="video/mp4">
                              Your browser does not support the video tag.
                            </video>
                          </div>
                          <div *ngIf="file.type === 'audio'" class="file-preview">
                            <audio controls class="audio-preview">
                              <source [src]="file.url" type="audio/mpeg">
                              Your browser does not support the audio element.
                            </audio>
                          </div>
                          <div *ngIf="file.type === 'document'"
                            class="file-preview pl-15 pr-5 document-preview-container">
                            <div class="document-icon">
                              <i class="fa fa-file-text mr-15" aria-hidden="true"></i>
                              <span class="document-name" matTooltip="{{ file.name }}">{{ file.name?.length > 35 ?
                                (file.name | slice:0:35) + '...' : file.name }}</span>
                            </div>
                            <button mat-icon-button [matMenuTriggerFor]="menu1" [disableRipple]="true">
                              <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu1="matMenu">
                              <button mat-menu-item (click)="downloadFile(file)">
                                <span>Download</span>
                              </button>
                            </mat-menu>
                          </div>
                        </ng-container>
                      </div>

                      <span *ngIf="message?.message?.length > 1000 && !message.isBlocked"
                        class="expand-text pointer d-block text-right m-10 dynamic-font" (click)="toggleMessage(message)">
                        {{ message.isExpanded ? 'Read Less' : 'Read More' }}
                      </span>
                    </div>
                    <div class="msg-reactions mt-10" [ngClass]="{ 'text-right': message.sentMsg }">
                      <ng-container *ngFor="let emoji of getEmojiKeys(message.reactions)">
                        <span class="fs-14 pointer actions"
                          [ngClass]="{ 'ml-5': message.sentMsg, 'mr-5': !message.sentMsg }"
                          (mouseenter)="showReactionUsers(emoji, message, emojiMenuTrigger)"
                          (mouseleave)="hideReactionUsers(emojiMenuTrigger)" #emojiMenuTrigger="matMenuTrigger"
                          [matMenuTriggerFor]="emojiMenu" [ngStyle]="{
                          'background-color': settingsData?.bg_secondary_color,
                          'color': settingsData?.font_primary_color
                        }">
                          <span class="mr-5 reaction">{{emoji}}</span>
                          <span>{{message.reactions[emoji]?.count}}</span>
                        </span>
                        <!-- Dropdown Menu for Reactions -->
                        <mat-menu #emojiMenu="matMenu" class="emoji-menu">
                          <ng-container *ngIf="reactionUsers.length > 0">
                            <button class="reaction-button" [ngStyle]="{'width' : '230px'}" mat-menu-item
                              *ngFor="let user of reactionUsers">
                              <span class="reaction-text">
                                <span *ngIf="!user.profileUrl"
                                  class="profile d-flex align-center j-c mr-10 uppercase fw-600 shrink-0">{{user.shortName}}</span>
                                <span *ngIf="user.profileUrl"
                                  [ngStyle]="{'background-image':' url(' + user.profileUrl + ')'}"
                                  class="artist-pic with-profile-pic mr-10 shrink-0">
                                </span>
                                <span class="user-name capitalize dynamic-font">
                                  {{ user.nickname > 14 ? (user.nickname | slice:0:11) + '...' : user.nickname }}
                                </span>
                              </span>
                              <span>{{hoveredReaction}}</span>
                            </button>
                          </ng-container>
                        </mat-menu>
                      </ng-container>
                      <span *ngIf="message.threadReplies?.length > 0" class="fs-14 pointer actions threads" [ngStyle]="{
                        'background-color': settingsData?.space_bg_primary_color,
                        'color': message.sentMsg || message.threadInvolvement ? settingsData?.space_font_primary_color : settingsData?.space_font_primary_color
                      }" (click)="openSidenav(message)"
                        [ngClass]="{ 'ml-5': message.sentMsg, 'mr-5': !message.sentMsg, 'active-thread': message.sentMsg || isUserInvolvedInThread(message) }">
                        <span>
                          <app-svg
                            [icon]="message.sentMsg || message.threadInvolvement ? 'active_thread' : 'inactive_thread'"
                            [color]="message.sentMsg || message.threadInvolvement ? settingsData?.space_font_primary_color : settingsData?.space_font_primary_color"></app-svg>
                        </span>
                        {{message.threadReplies.length}}
                      </span>
                    </div>
                  </span>
                </div>



              </div>

              <div [ngStyle]="{
                'color': settingsData?.space_font_main_color,
                }" class="d-flex align-center j-c h-100 opacity-7 channeltext dynamic-font" *ngIf="!messagesList.length">
                No messages yet. Start the conversation by sending a message.
              </div>
            </div>
            <emoji-mart *ngIf="isEmojiInputVisible" [showPreview]="false" [isNative]="true" [set]="'native'"
              (emojiClick)="addEmojiToInput($event)" [showSingleCategory]="false" [emojisToShowFilter]="filter"
              [enableSearch]="false" class="emoji-thread-picker">
            </emoji-mart>
            <div class="input-box">

              <span [ngStyle]="{
              'background-color': settingsData?.space_bg_secondary_color,
              'color': settingsData?.space_font_secondary_color
            }">
                <span class="icon-group p-0 3">
                  <app-svg class="file-upload-icon icon  mr-5"
                    (click)="userInfo?.id ? fileInput.click() :$event.stopPropagation()" [icon]="'file-upload'" [color]="settingsData?.space_font_secondary_color"
                    matTooltip="Attach files"
                    [ngStyle]="{'padding': '7px', 'border-radius': '6px', 'margin-top': '3px','cursor':userInfo?.id ? 'pointer' :'not-allowed'}"></app-svg>
                  <input type="file" #fileInput accept="*" multiple style="display: none"
                    (change)="onFileSelected($event)" />
                  <app-svg class="pointer icon emoji-input" style="padding:3px" [icon]="'emoji-input'" [color]="settingsData?.space_font_secondary_color"
                    (click)="toggleEmojiPicker()" matTooltip="Emoji"
                    [ngStyle]="{'padding': '5px', 'border-radius':  '6px', 'margin-top': '3px'}"></app-svg>
                  <app-svg class="pointer icon emoji-input" style="padding:3px" [icon]="'poll'" [color]="settingsData?.space_font_secondary_color"
                    (click)="createPoll()" matTooltip="Poll"
                    [ngStyle]="{'padding': '4px', 'border-radius':  '6px', 'margin-top': '0px','margin-left':'6px'}"></app-svg>
                  <app-svg class="pointer" [icon]="'tips-icon'" [color]="settingsData?.space_font_secondary_color" *ngIf="channelDetails?.enableTips"
                    (click)="sendTips()" matTooltip="Tips" style="width: 25px;height: 25px;margin-left: 10px;"></app-svg>
                  <!-- <mat-icon class="icon poll pointer" (click)="createPoll()" matTooltip="Polls" [ngStyle]="{'background-color': settingsData?.bg_primary_color || 'white', 'color': settingsData?.font_primary_color || 'black'}">poll</mat-icon> -->
                </span>
              </span>
              <div class="message-container">
                <div>
                  <textarea #messageInput [ngClass]="{'h-50': !userInput.length}" [(ngModel)]="userInput"
                    (keydown)="handleKeyDown($event)" placeholder="Share your thoughts..." rows="1"
                    (input)="adjustTextareaHeight($event)"></textarea>
                  <div *ngIf="selectedFiles.length > 0" class="file-tags plr-10 pb-10">
                    <div class="d-flex align-center file-tag fs-15 ptb-5 plr-10"
                      [ngStyle]="{'background-color':settingsData?.subs_bg_primary_color}"
                      *ngFor="let file of selectedFiles; let i = index">
                      <span class="file-name p-0" matTooltip="{{ file.name }}">
                        {{ file.name.length > 35 ? (file.name | slice:0:35) + '...' : file.name }}
                      </span>
                      <span class="pointer remove-file p-0 pt-5"
                        (click)="removeFile(i)"><mat-icon>close</mat-icon></span>
                    </div>
                  </div>
                </div>
                <button class="send-button" [ngStyle]="{
                'background-color': settingsData?.space_bg_secondary_color,
                'color':settingsData?.space_font_secondary_color,
                'border': 'none',
                'border-radius': '15px',
                'cursor': userInfo?.id ? 'pointer' : 'not-allowed'
              }" (click)="sendMessage()">
                  <div class="send-icon text-center fs-20 pointer m-12 pt-5" fxFlex="15%" fxFlex.xs="25%">
                    <span class="material-icons  notranslate"
                      [ngStyle]="{'cursor': userInfo?.id ? 'pointer' : 'not-allowed'}">
                      send
                    </span>
                  </div>
                </button>
              </div>

            </div>
          </div>
        </div>

      </ng-container>
      <ng-template #contentLoading>
        <div fxFlex="100%" class="mt-10" *ngIf="isCheckingChannel">
          <content-loading [width]="'width85Per'"></content-loading>
          <content-loading [width]="'width65Per'"></content-loading>
          <content-loading [width]="'width45Per'"></content-loading>
          <content-loading [width]="'width30Per'"></content-loading>
          <content-loading [width]="'width45Per'"></content-loading>
          <content-loading [width]="'width85Per'"></content-loading>
          <content-loading [width]="'width65Per'"></content-loading>
          <content-loading [width]="'width45Per'"></content-loading>
          <content-loading [width]="'width30Per'"></content-loading>
          <content-loading [width]="'width45Per'"></content-loading>
          <content-loading [width]="'width85Per'"></content-loading>
          <content-loading [width]="'width65Per'"></content-loading>
          <content-loading [width]="'width45Per'"></content-loading>
          <content-loading [width]="'width30Per'"></content-loading>
          <content-loading [width]="'width45Per'"></content-loading>
          <content-loading [width]="'width85Per'"></content-loading>
          <content-loading [width]="'width65Per'"></content-loading>
          <content-loading [width]="'width45Per'"></content-loading>
          <content-loading [width]="'width30Per'"></content-loading>
          <content-loading [width]="'width45Per'"></content-loading>
          <content-loading [width]="'width85Per'"></content-loading>
          <content-loading [width]="'width65Per'"></content-loading>
          <content-loading [width]="'width45Per'"></content-loading>
          <content-loading [width]="'width30Per'"></content-loading>
          <content-loading [width]="'width45Per'"></content-loading>
        </div>
      </ng-template>
      <div class="d-flex align-center j-c h-100 opacity-7 fs-18 w-100 channeltext dynamic-font"
        *ngIf="!isChannelAvailable && !isCheckingChannel">
        Space is not available
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- Image Preview Overlay -->
  <div *ngIf="showImagePreview" class="image-preview-overlay" (click)="closeImagePreview()">
    <div class="image-preview-container" (click)="$event.stopPropagation()" [class.fullscreen]="isFullscreen">
      <!-- Navigation Arrows -->
      <button *ngIf="currentMessageImages.length > 1" class="nav-arrow left"
        (click)="$event.stopPropagation(); navigateImage(-1)">
        <mat-icon>chevron_left</mat-icon>
      </button>

      <!-- Main Image with Zoom -->
      <div class="image-wrapper">
        <img [src]="previewImageUrl" alt="Preview" class="full-image-preview" [style.transform]="'scale(' + scale + ')'"
          (click)="$event.stopPropagation()" />
      </div>

      <button *ngIf="currentMessageImages.length > 1" class="nav-arrow right"
        (click)="$event.stopPropagation(); navigateImage(1)">
        <mat-icon>chevron_right</mat-icon>
      </button>

      <!-- Top Controls -->
      <div class="preview-controls top">
        <div class="left-controls">
          <button mat-icon-button (click)="$event.stopPropagation(); closeImagePreview()" matTooltip="Close (Esc)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="right-controls">
          <button mat-icon-button (click)="$event.stopPropagation(); downloadImage()" matTooltip="Download">
            <mat-icon>download</mat-icon>
          </button>
          <button mat-icon-button (click)="$event.stopPropagation(); toggleFullscreen()"
            matTooltip="{{ isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen' }}">
            <mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
          </button>
        </div>
      </div>

      <!-- Bottom Controls -->
      <div class="preview-controls bottom">
        <div class="zoom-controls">
          <button mat-icon-button (click)="$event.stopPropagation(); zoomImage(false)" [disabled]="scale <= 0.5"
            matTooltip="Zoom Out">
            <mat-icon>zoom_out</mat-icon>
          </button>
          <span class="zoom-level">{{ scale * 100 | number:'1.0-0' }}%</span>
          <button mat-icon-button (click)="$event.stopPropagation(); zoomImage(true)" [disabled]="scale >= 3"
            matTooltip="Zoom In">
            <mat-icon>zoom_in</mat-icon>
          </button>
          <button mat-icon-button (click)="$event.stopPropagation(); resetZoom()" [disabled]="scale === 1"
            matTooltip="Reset Zoom">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>

        <div class="file-info">
          <span class="filename" matTooltip="{{ previewFilename }}">{{ previewFilename }}</span>
        </div>

        <div *ngIf="currentMessageImages.length > 1" class="image-counter">
          {{ currentImageIndex + 1 }} / {{ currentMessageImages.length }}
        </div>
      </div>


    </div>
  </div>

  <div *ngIf="isBlockedChannel" class="d-flex w-100 fs-18 block-channel dynamic-font" [ngStyle]="{
    'color': settingsData?.space_font_main_color
  }">
    {{ isCheckingChannel ? 'Connecting to space...' : 'This Space has been blocked.' }}
  </div>
</div>